// common
import { useState } from "react";

/**
 * @function useHeaderMobile
 * @desc 모바일 헤더 관련 로직을 처리하는 커스텀 훅
 * @returns {Object} 모바일 메뉴의 상태 및 관련 함수
 */
export const useHeaderMobile = () => {
  // 로컬 상태
  const [isToggleMenu, setIsToggleMenu] = useState(false);

  /**
   * @function onVisibleMobileMenu
   * @desc 모바일 환경의 메뉴 표출 제어
   * @returns {void} 햄버거 버튼 토글 시, 메뉴 표출 제어
   */
  const onVisibleMobileMenu = () => {
    setIsToggleMenu((prev) => !prev);
  };

  return {
    isToggleMenu,
    setIsToggleMenu,
    onVisibleMobileMenu,
  };
};
